import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PrimeNGModule } from '@shared/primeng/primeng.module';

import { formatKlDateValue } from '../../utils/kl-date-format';

/** Payload from GET `{resource}/{id}/persist`. */
export type KlEntryAuditPayload = Record<string, unknown> | null;

@Component({
  selector: 'kl-entry-info-dialog',
  standalone: true,
  imports: [TranslateModule, PrimeNGModule],
  templateUrl: './kl-entry-info-dialog.html',
  styleUrl: './kl-entry-info-dialog.scss',
})
export class KlEntryInfoDialogComponent {
  readonly audit = input<KlEntryAuditPayload>(null);

  userName(user: unknown): string {
    if (user && typeof user === 'object' && 'full_name' in user) {
      return String((user as { full_name?: string }).full_name ?? '');
    }
    return '';
  }

  dateTime(raw: unknown): string {
    if (raw == null || raw === '') {
      return '—';
    }
    return formatKlDateValue(raw, true);
  }
}
